import type { InferType, ObjectSchema } from 'yup';
import type { RealtimeEventType } from '../enums.js';
// import { DispatchEvent } from './DispatchEvent.js';

export interface IRealtimeEvent<T extends RealtimeEventType, S extends ObjectSchema<any> | null> {
  data: S extends null ? null : InferType<NonNullable<S>>;
  schema: S;
  // toDispatchEvent(fluid: `fluid:v1:account:${string}`): DispatchEvent<IRealtimeEvent<T, S>>;
  toJSON(): string;
  toJSONObject(): { data: S extends null ? null : InferType<NonNullable<S>>; op: T };
  type: T;
}

function CreateCommand<T extends RealtimeEventType, S extends ObjectSchema<any> | null>(type: T, schema: S) {
  return class RealtimeEvent implements IRealtimeEvent<T, S> {
    public static readonly type = type;

    public readonly type: T = type;

    public static readonly schema = schema;

    public readonly schema: S = schema;

    public readonly data: S extends null ? null : InferType<NonNullable<S>>;

    public constructor(public readonly payload?: InferType<NonNullable<S>>) {
      if (schema) {
        schema.validateSync(payload, { strict: true });
      } else if (payload) {
        throw new Error('Payload should be null');
      }

      this.data = payload ? (schema?.cast(payload) ?? payload) : (null as S extends null ? null : InferType<NonNullable<S>>);
    }

    public toJSON(): string {
      const data = {
        op: this.type,
      } as { data: S extends null ? null : InferType<NonNullable<S>>; op: T };

      if (this.data) {
        data.data = this.data;
      }

      return JSON.stringify(data);
    }

    public toJSONObject(): { data: S extends null ? null : InferType<NonNullable<S>>; op: T } {
      const data = {
        op: this.type,
      } as { data: S extends null ? null : InferType<NonNullable<S>>; op: T };

      if (this.data) {
        data.data = this.data;
      }

      return data;
    }
  };
}

export { CreateCommand };
